import { graphqlErrorCode, graphqlErrorMessage, isStrongAuthError } from '@/lib/graphqlError';

/**
 * Turns a failed voucher rule save or activation into a sentence the admin can
 * act on. Go answers FORBIDDEN when the admin has no ticket access in the venue
 * of the rule's night (or the night is unknown) and BAD_USER_INPUT for
 * invalid fields and for the backfill caps (too many claimed tickets, at most 200
 * rules per bulk call).
 */
export function voucherRuleErrorMessage(err: unknown, context: 'save' | 'activate'): string {
  const code = graphqlErrorCode(err);
  if (code === 'FORBIDDEN' && !isStrongAuthError(err)) {
    return context === 'save'
      ? 'You cannot use that night: you need ticket access in its venue, or it no longer exists. Pick another night.'
      : 'A Ticket claimed rule can only be activated by someone with ticket access in its night’s venue. Nothing was changed.';
  }
  if (code === 'BAD_USER_INPUT') {
    const message = graphqlErrorMessage(err);
    return context === 'save' ? `Check the form: ${message}` : message;
  }
  return graphqlErrorMessage(err);
}
